<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4 6V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4H6C4.89543 4 4 4.89543 4 6ZM10 6H12V9H18V11H12V18H10V11H6V9H10V6Z"
    fill="#13AF77"
  />
</template>
